import { Link, useLocation } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import { IconArrowLeft } from '../components/ui/Icon'
import { HOME_BY_LANG, langFromPath } from '../lib/routes'

const COPY = Object.freeze({
    tr: { title: 'Sayfa bulunamadı', body: 'Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.', back: 'Ana sayfaya dön' },
    en: { title: 'Page not found', body: 'The page you are looking for may have moved or never existed.', back: 'Back to the home page' },
    de: { title: 'Seite nicht gefunden', body: 'Die gesuchte Seite wurde verschoben oder existiert nicht.', back: 'Zur Startseite' },
})

/**
 * Any path outside the route table. The SPA answers it with a 200 (the host's
 * fallback serves the home snapshot), so the page says noindex itself and
 * offers the way home, in the path's language.
 */
export default function NotFound() {
    const { pathname } = useLocation()
    const lang = langFromPath(pathname)
    const t = COPY[lang]

    return (
        <>
            <SEO title={t.title} lang={lang} noindex />
            <Navbar lang={lang} />
            <main id="main-content" className="post-missing container" lang={lang}>
                <h1>404</h1>
                <p className="lead">{t.title}. {t.body}</p>
                <Link to={HOME_BY_LANG[lang]} className="btn btn--ghost" viewTransition>
                    <IconArrowLeft />
                    {t.back}
                </Link>
            </main>
            <Footer lang={lang} />
        </>
    )
}
